import { TextInput, DateInput } from '@/components';

export interface ServiceFormViewProps {
  title: string;
  serviceName?: string;
  businessDisplayName?: string;
  vehicleTypeName?: string;
  serviceTypeName?: string;
  fee?: string | number;
  min?: string | number;
  validFrom?: Date | string;
  validTo?: Date | string;
  vehicleTypesLoading?: boolean;
  serviceTypesLoading?: boolean;
}

function ServiceFormView({
  title,
  serviceName,
  businessDisplayName,
  vehicleTypeName,
  serviceTypeName,
  fee,
  min,
  validFrom,
  validTo,
  vehicleTypesLoading = false,
  serviceTypesLoading = false,
}: ServiceFormViewProps) {
  return (
    
    <div className="w-full p-[50px] flex flex-col bg-white rounded-[5px] shadow-[0_0_4px_rgba(0,0,0,0.1)] gap-5">
      <h1 className="mb-[15px] font-bold text-2xl">{title}</h1>

      {(serviceName !== undefined || businessDisplayName) && (
        <div className="flex gap-3">
          {serviceName !== undefined && (
            <div className="flex-1">
              <TextInput
                name="name"
                placeholder="Nombre"
                value={serviceName}
                onChange={() => {}}
                disabled
              />
            </div>
          )}
          {businessDisplayName && (
            <div className="flex-1">
              <TextInput
                name="business"
                placeholder="Negocio"
                value={businessDisplayName}
                onChange={() => {}}
                disabled
              />
            </div>
          )}
        </div>
      )}

      <div className="flex gap-3">
        <div className="flex-1">
          <TextInput
            name="vehicleType"
            placeholder={vehicleTypesLoading ? 'Cargando...' : 'Tipo de vehículo'}
            value={vehicleTypeName ?? ''}
            onChange={() => {}}
            disabled
          />
        </div>
        <div className="flex-1">
          <TextInput
            name="serviceType"
            placeholder={serviceTypesLoading ? 'Cargando...' : 'Tipo de servicio'}
            value={serviceTypeName ?? ''}
            onChange={() => {}}
            disabled
          />
        </div>
      </div>

      <div className="flex gap-3">
        <div className="flex-1">
          <TextInput
            name="fee"
            placeholder="Tarifa"
            type="number"
            value={fee ?? ''}
            onChange={() => {}}
            disabled
          />
        </div>
        <div className="flex-1">
          <TextInput
            name="min"
            placeholder="Mínimo"
            type="number"
            value={min ?? ''}
            onChange={() => {}}
            disabled
          />
        </div>
      </div>

      <div className="flex gap-3">
        <div className="flex-1">
          <DateInput
            name="validFrom"
            placeholder="Vigencia desde"
            value={validFrom ? (typeof validFrom === 'string' ? new Date(validFrom) : validFrom) : null}
            onChange={() => {}}
            disabled
          />
        </div>
        <div className="flex-1">
          <DateInput
            name="validTo"
            placeholder="Vigencia hasta"
            value={validTo ? (typeof validTo === 'string' ? new Date(validTo) : validTo) : null}
            onChange={() => {}}
            disabled
          />
        </div>
      </div>
    </div>
  );
}

export default ServiceFormView;
